export default __webpack_public_path__ + "img/HIRI_The_Pulse_of_the_Home_Improvement_Industry_iPad.png";